<script setup lang="ts">
const { $axios }: any = useNuxtApp();

const promos = reactive<any>([]);

const props = defineProps({
  isSquare: Boolean,
});

const getBanner = async () => {
  try {
    const { status, data } = await $axios("/cms/banner/get");
    if (status) Object.assign(promos, data.data);
  } catch (error) {
    console.error("Error fetching banner:", error);
  }
};

onMounted(() => {
  getBanner();
});

const openUrl = (url: string) => window.open(url, "_blank");
</script>

<template>
  <!-- <div class="bg-white "> -->
  <div class="">
    <ClientOnly>
      <Swiper
        :modules="[SwiperAutoplay, SwiperPagination]"
        :slides-per-view="1"
        :loop="true"
        :pagination="props.isSquare ? false : { clickable: true }"
        :autoplay="{
          delay: 4000,
          disableOnInteraction: true,
        }"
      >
        <SwiperSlide v-for="(data, dataIdx) in promos">
          <NuxtImg
            v-if="data.url"
            preset="thumb"
            :key="`promo-link${dataIdx}`"
            :src="data.images"
            alt="promo-link"
            class="w-full cursor-pointer object-cover"
            :class="props.isSquare ? '' : 'rounded-xl'"
            @click="openUrl(data.url)"
          />

          <NuxtImg
            v-else
            preset="thumb"
            :key="`promo-${dataIdx}`"
            :src="data.images"
            alt="promo"
            class="w-full cursor-pointer object-cover"
            :class="props.isSquare ? '' : 'rounded-xl'"
          />
        </SwiperSlide>
      </Swiper>
    </ClientOnly>
  </div>
  <!-- </div> -->
</template>
